<template>
    <div class="ayuda-container" data-app>
        <section class="doc-section ayuda-scope">
            <div class="container-fluid px-0">

                <!-- Selector Plataforma -->
                <div class="mb-6">
                    <BotonesNavegacion @cambio-plataforma="plataformaActual = $event" />
                </div>

                <header class="header-container mb-4">
                    <h1 class="main-title">Registro de Actividades del Usuario</h1>
                    <p class="description">
                        Para visualizar la lista de acciones realizadas por los usuarios en el sistema,
                        ir al menú lateral izquierdo y hacer clic sobre la opción <strong>Bitácora</strong>.
                    </p>
                </header>

                <div class="doc-note note-warning mb-5">
                    <svg class="note-icon" width="15" height="15" viewBox="0 0 16 16" fill="none">
                        <path d="M8 2L14.9 14H1.1L8 2Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                        <path d="M8 7v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                        <circle cx="8" cy="11.5" r="0.75" fill="currentColor"/>
                    </svg>

                    <div class="note-body">
                        <span class="note-label">Acceso restringido</span>
                        <p>Únicamente el usuario <strong>master</strong> podrá acceder a esta vista.</p>
                    </div>
                </div>

                <div class="section-container mb-5">

                    <div class="section-title-bar mb-4">
                        <h2>Acceso y Vista Principal</h2>
                    </div>

                    <div class="row mx-0 mb-4">

                        <div class="col-12 px-0 mb-3">

                            <h3 class="simple-title mb-2">
                                Acceso al Módulo
                            </h3>

                            <p class="card-text mb-0">
                                Despliegue el menú lateral izquierdo de la plataforma y seleccione
                                la opción <strong>Bitácora</strong> para cargar la interfaz de
                                registros históricos de acciones.
                            </p>

                        </div>

                        <div class="col-12 px-0">

                            <div class="carrusel-wrapper-box p-2">

                                <transition name="fade" mode="out-in">
                                    <CarruselAciqui
                                        :key="plataformaActual + '-acceso'"
                                        :items="itemsAcceso"
                                    />
                                </transition>

                            </div>

                        </div>

                    </div>

                    <p class="section-desc mt-5">
                        Una vez en la vista Bitácora, se visualizan los elementos numerados en la siguiente imagen:
                    </p>

                    <div class="main-reference row mx-0">

                        <div class="col-12 col-lg-7 px-0 pr-lg-4 mb-4 mb-lg-0">

                            <div class="carrusel-wrapper-box p-2">

                                <transition name="fade" mode="out-in">
                                    <CarruselAciqui
                                        :key="plataformaActual + '-paginacion'"
                                        :items="itemsPaginacion"
                                    />
                                </transition>

                            </div>

                        </div>

                        <div class="col-12 col-lg-5 px-0">

                            <div class="info-grid-vertical">

                                <div
                                    v-for="(info, index) in referenciasBitacora"
                                    :key="index"
                                    class="info-card-step"
                                >
                                    <span class="step-num">
                                        {{ info.numero }}
                                    </span>

                                    <p class="step-text mb-0" v-html="info.texto"></p>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <hr class="section-divider my-5" />

                <div class="section-container mb-5">

                    <div class="section-title-bar mb-4">
                        <h2>Búsqueda por Texto</h2>
                    </div>

                    <div class="row mx-0 mb-4">

                        <div class="col-12 px-0 mb-3">

                            <p class="section-desc">
                                El campo <strong>"Buscar"</strong> permite filtrar los datos cargados en la tabla
                                mediante texto clave. Al escribir, se activa el botón <strong>"Limpiar Búsqueda"</strong>
                                para restablecer el filtro.
                            </p>

                            <ol class="lista-instrucciones mb-4">
                                <li>Ingresar la palabra o texto clave para realizar el filtrado.</li>
                                <li>El sistema mostrará en la tabla el resultado de la búsqueda.</li>
                                <li>Presionar <strong>"Limpiar Búsqueda"</strong> para restablecer.</li>
                            </ol>

                            <div class="doc-note note-tip mb-4">

                                <div class="note-body">
                                    <span class="note-label">Ejemplo</span>

                                    <p>
                                        Buscar <strong>"Inicio"</strong> devuelve los registros de inicio de sesión.
                                    </p>
                                </div>

                            </div>

                        </div>

                        <div class="col-12 px-0">

                            <div class="carrusel-wrapper-box p-2">

                                <transition name="fade" mode="out-in">
                                    <CarruselAciqui
                                        :key="plataformaActual + '-texto'"
                                        :items="itemsBusquedaTexto"
                                    />
                                </transition>

                            </div>

                        </div>

                    </div>

                </div>

                <hr class="section-divider my-5" />

                <div class="section-container mb-5">

                    <div class="section-title-bar mb-4">
                        <h2>Búsqueda por Tipo de Acción y Fechas</h2>
                    </div>

                    <p class="section-desc">
                        Las acciones se muestran ordenadas de forma descendente para ver siempre las más
                        recientes. También es posible realizar búsquedas específicas combinando el tipo
                        de filtrado con un rango de fechas.
                    </p>

                    <div class="carrusel-wrapper-box p-3">

                        <transition name="fade" mode="out-in">
                            <CarruselAciqui
                                :key="plataformaActual + '-filtrado'"
                                :items="carruselBusquedaFiltrado"
                            />
                        </transition>

                    </div>

                </div>

            </div>
        </section>
    </div>
</template>

<script>
import CarruselAciqui from './Carruselimg.vue';
import BotonesNavegacion from './BotonesNavegacion.vue';

export default {
    name: 'BitacoraDoc',

    components: {
        CarruselAciqui,
        BotonesNavegacion
    },

    data() {
        return {
            plataformaActual: 'web',

            webData: {
                acceso: [
                    {
                        nombre: "Acceso a la bitácora",
                        url: 'img/bitacora/Acceso_Bitacora.png'
                    }
                ],

                paginacion: [
                    {
                        nombre: "Elementos de la bitácora",
                        url: 'img/bitacora/Paginacion_Bitacora.png'
                    }
                ],

                busquedaTexto: [
                    {
                        nombre: "Búsqueda por texto",
                        url: 'img/bitacora/Ejemplo_Busqueda_Texto.png'
                    }
                ],

                filtrado: [
                    {
                        nombre: "Búsqueda por tipo de acción",
                        url: "img/bitacora/Elemento_Busqueda_Tipo_Accion.png",
                        descripcion: "1. Seleccionar un tipo de filtrado (default: Historial completo). 2. Seleccionar rango de fechas. 3. Clic en Consultar para ejecutar la búsqueda con los parámetros seleccionados."
                    },
                    {
                        nombre: "Sin resultados encontrados",
                        url: "img/bitacora/Mensaje_Sin_Resultados.png",
                        descripcion: "Si no hay registros que coincidan, la tabla se mostrará vacía con el mensaje 'No se encontraron registros' y una alerta emergente indicando que no hay historial en el rango seleccionado."
                    }
                ]
            },

            mobileData: {
                acceso: [
                    {
                        nombre: "Acceso a la bitácora",
                        url: 'img/bitacora/Acceso_Bitacora_Movil.png'
                    }
                ],

                paginacion: [
                    {
                        nombre: "Elementos de la bitácora",
                        url: 'img/bitacora/Paginacion_Bitacora_Movil.png'
                    }
                ],

                busquedaTexto: [
                    {
                        nombre: "Búsqueda por texto",
                        url: 'img/bitacora/Ejemplo_Busqueda_Texto_Movil.png'
                    }
                ],

                filtrado: [
                    {
                        nombre: "Búsqueda por tipo de acción",
                        url: "img/bitacora/Elemento_Busqueda_Tipo_Accion_Movil.png",
                        descripcion: "1. Seleccionar un tipo de filtrado (default: Historial completo). 2. Seleccionar rango de fechas. 3. Clic en Consultar para ejecutar la búsqueda con los parámetros seleccionados."
                    },
                    {
                        nombre: "Sin resultados encontrados",
                        url: "img/bitacora/Mensaje_Sin_Resultados_Movil.png",
                        descripcion: "Si no hay registros que coincidan, la tabla se mostrará vacía con el mensaje 'No se encontraron registros' y una alerta emergente indicando que no hay historial en el rango seleccionado."
                    }
                ]
            },

            referenciasBitacora: [
                { numero: '1', texto: 'Campo <strong>Buscar</strong>: permite filtrar los elementos de la tabla.' },
                { numero: '2', texto: 'Botón <strong>Limpiar Búsqueda</strong>: limpia el campo buscar. Se activa únicamente al ingresar texto.' },
                { numero: '3', texto: 'Desplegable de <strong>tipo de filtrado</strong>. Por default tiene seleccionada la opción "Historial completo".' },
                { numero: '4', texto: 'Selector de <strong>rango de fechas</strong> tipo calendario para consultas por filtrado.' },
                { numero: '5', texto: 'Botón <strong>Consultar</strong>. Ejecuta la consulta con el tipo de filtrado y rango de fechas seleccionado.' },
                { numero: '6', texto: '<strong>Tabla de acciones</strong> registradas: nombre del usuario, rol, grupo, descripción de la acción y fecha.' },
            ]
        }
    },

    computed: {
        itemsAcceso() {
            return this.plataformaActual === 'web'
                ? this.webData.acceso
                : this.mobileData.acceso
        },

        itemsPaginacion() {
            return this.plataformaActual === 'web'
                ? this.webData.paginacion
                : this.mobileData.paginacion
        },

        itemsBusquedaTexto() {
            return this.plataformaActual === 'web'
                ? this.webData.busquedaTexto
                : this.mobileData.busquedaTexto
        },

        carruselBusquedaFiltrado() {
            return this.plataformaActual === 'web'
                ? this.webData.filtrado
                : this.mobileData.filtrado
        }
    }
}
</script>

<style scoped>
/* ── Base ─────────────────────────────────────────── */
.doc-section { color: var(--text-color); padding: 30px 0; }
.main-title { font-family: 'Lexend', sans-serif; font-weight: 700; font-size: 24px; color: var(--primary-color); margin-bottom: 2px; }
.subtitle { font-size: 12px; font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; color: var(--primary-color); opacity: 0.6; margin-bottom: 10px; }
.description { font-size: 15px; line-height: 1.8; color: var(--text-color); opacity: 0.85; }

/* ── Secciones ────────────────────────────────────── */
.section-title-bar h2 { font-size: 19px; font-weight: 700; color: var(--primary-color); margin: 0; }
.section-desc { font-size: 14.5px; color: var(--text-color); opacity: 0.85; margin-bottom: 15px; line-height: 1.65; }
.section-divider { border: 0; height: 1px; background: var(--border-color); }

/* ── Texto sin recuadros ───────────────────────────── */
.simple-title { font-size: 16px; font-weight: 700; color: var(--primary-color); }
.card-text { font-size: 14.5px; color: var(--text-color); opacity: 0.9; line-height: 1.65; }
.lista-instrucciones { padding-left: 20px; margin: 0; }
.lista-instrucciones li { font-size: 14.5px; line-height: 1.7; color: var(--text-color); margin-bottom: 8px; }

/* ── Grid de referencias ──────────────────────────── */
.info-grid-vertical { display: flex; flex-direction: column; gap: 8px; }
.info-card-step { display: flex; gap: 12px; align-items: flex-start; padding: 12px 14px; border-radius: 8px; background: var(--code-bg); border: 1px solid var(--border-color); }
.step-num { width: 26px; height: 26px; background: var(--primary-color); color: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 11px; flex-shrink: 0; }
.step-text { font-size: 13px; color: var(--text-color); line-height: 1.6; opacity: 0.85; }

/* ── Carrusel Box ────────────────────────────────── */
.carrusel-wrapper-box { background: var(--code-bg); border-radius: 10px; border: 1px solid var(--border-color); }

/* ── Notas ────────────────────────────────────────── */
.doc-note { display: flex; gap: 10px; padding: 13px 16px; border-radius: 6px; border: 1px solid; font-size: 14px; }
.note-label { font-size: 10.5px; font-weight: 700; text-transform: uppercase; }
.note-warning { background: #fffbeb; border-color: #d97706; color: #d97706; }
.note-tip { background: #f0fdf4; border-color: #16a34a; color: #16a34a; }

@media (max-width: 768px) {
    .main-title { font-size: 20px; }
}
</style>```